import { computed } from 'vue'
import store from '@/store'

// Cosmetic permission helpers backed by the auth store. The backend remains the
// source of truth — these only gate the UI (disable/hide actions). In
// development the store is populated from GET /me (the seeded local_dev user),
// so the UI reflects real per-feature roles there too.
export const usePermissions = () => {
  const can = (feature: string, action = 'view'): boolean =>
    store.getters['auth/can'](feature, action)

  const canManageUsers = computed<boolean>(
    () => store.getters['auth/canManageUsers']
  )

  const canCreateAnyTemplate = computed<boolean>(
    () => store.getters['auth/canCreateAnyTemplate']
  )

  return { can, canManageUsers, canCreateAnyTemplate }
}
